(function(){
  "use strict";

  var root=document.getElementById("wl-camera-page");
  if(!root)return;

  var config=window.WagLifeCameraConfig||{};
  var startPanel=root.querySelector("#wl-camera-start");
  var startButton=root.querySelector("#wl-camera-start-button");
  var fileInput=root.querySelector("#wl-camera-file-input");
  var viewfinder=root.querySelector("#wl-camera-viewfinder");
  var video=root.querySelector("#wl-camera-video");
  var preview=root.querySelector("#wl-camera-preview");
  var previewImage=root.querySelector("#wl-camera-preview-image");
  var canvas=root.querySelector("#wl-camera-canvas");
  var shutterButton=root.querySelector("#wl-camera-shutter");
  var switchButton=root.querySelector("#wl-camera-switch");
  var closeCameraButton=root.querySelector("#wl-camera-close-camera");
  var flashButton=root.querySelector("#wl-camera-flash");
  var facingLabel=root.querySelector("#wl-camera-facing-label");
  var stageActions=root.querySelector("#wl-camera-stage-actions");
  var retakeButton=root.querySelector("#wl-camera-retake");
  var usePhotoButton=root.querySelector("#wl-camera-use-photo");
  var editorDisabled=root.querySelector("#wl-camera-editor-disabled");
  var editorControls=root.querySelector("#wl-camera-editor-controls");
  var captionInput=root.querySelector("#wl-camera-caption");
  var captionCount=root.querySelector("#wl-camera-caption-count");
  var saveButton=root.querySelector("#wl-camera-save-image");
  var shareButton=root.querySelector("#wl-camera-share-image");
  var newPhotoButton=root.querySelector("#wl-camera-new-photo");
  var stateTitle=root.querySelector("#wl-camera-state-title");
  var stateCopy=root.querySelector("#wl-camera-state-copy");
  var helpButton=root.querySelector("#wl-camera-help");
  var toast=root.querySelector("#wl-camera-toast");
  var recentSection=root.querySelector(".wl-memories-recent");
  var recentEmpty=root.querySelector(".wl-memories-empty");

  var stream=null;
  var facingMode=config.defaultFacingMode||"environment";
  var capturedBlob=null;
  var capturedObjectUrl="";
  var editorReady=false;
  var isStarting=false;
  var memoryStorageKey="waglife.memories.v1";
  var maxStoredMemories=12;

  function setState(title,copy){
    if(stateTitle)stateTitle.textContent=title;
    if(stateCopy)stateCopy.textContent=copy;
  }

  function showToast(message){
    if(!toast)return;
    toast.textContent=message;
    toast.hidden=false;
    window.clearTimeout(showToast.timer);
    showToast.timer=window.setTimeout(function(){
      toast.hidden=true;
    },2400);
  }

  function stopCamera(){
    if(stream){
      stream.getTracks().forEach(function(track){
        try{track.stop();}catch(error){}
      });
      stream=null;
    }

    if(video){
      video.pause();
      video.srcObject=null;
    }
  }

  function revokeCapturedUrl(){
    if(capturedObjectUrl){
      URL.revokeObjectURL(capturedObjectUrl);
      capturedObjectUrl="";
    }
  }

  function resetPreview(){
    capturedBlob=null;
    revokeCapturedUrl();

    if(previewImage){
      previewImage.removeAttribute("src");
    }

    if(preview)preview.hidden=true;
    if(stageActions)stageActions.hidden=true;
    if(editorDisabled)editorDisabled.hidden=false;
    if(editorControls)editorControls.hidden=true;
    editorReady=false;
  }

  function showStartState(){
    stopCamera();
    resetPreview();

    if(startPanel)startPanel.hidden=false;
    if(viewfinder)viewfinder.hidden=true;

    setState(
      "Ready when you are",
      "Take a new photo or choose one from your library to create a memory."
    );
  }

  function getCameraConstraints(){
    return {
      audio:false,
      video:{
        facingMode:{ideal:facingMode},
        width:{ideal:1920},
        height:{ideal:1080}
      }
    };
  }

  function cameraErrorMessage(error){
    var name=error && error.name ? error.name : "";

    if(name==="NotAllowedError" || name==="SecurityError"){
      return {
        title:"Camera permission blocked",
        copy:"Allow camera access in your browser or app settings, then try again."
      };
    }

    if(name==="NotFoundError" || name==="DevicesNotFoundError"){
      return {
        title:"No camera found",
        copy:"This device did not report an available camera. Choose a photo instead."
      };
    }

    if(name==="NotReadableError" || name==="TrackStartError"){
      return {
        title:"Camera is already in use",
        copy:"Close other apps using the camera, then try again."
      };
    }

    return {
      title:"Camera could not start",
      copy:"Choose a photo instead or try opening the camera again."
    };
  }

  async function startCamera(){
    if(isStarting)return;

    if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){
      setState(
        "Live camera unavailable",
        "Choose a photo from your device instead."
      );
      showToast("Live camera is not supported here.");
      if(fileInput)fileInput.click();
      return;
    }

    isStarting=true;
    if(startButton)startButton.disabled=true;

    stopCamera();
    resetPreview();

    setState("Opening camera…","Waiting for camera permission.");

    try{
      stream=await navigator.mediaDevices.getUserMedia(getCameraConstraints());

      if(video){
        video.srcObject=stream;
        await video.play();
      }

      if(startPanel)startPanel.hidden=true;
      if(preview)preview.hidden=true;
      if(viewfinder)viewfinder.hidden=false;
      if(stageActions)stageActions.hidden=true;

      if(facingLabel){
        facingLabel.textContent=facingMode==="user" ? "Front Camera" : "Rear Camera";
      }

      setState(
        "Camera ready",
        "Frame the moment and tap the shutter when you are ready."
      );
    }catch(error){
      var message=cameraErrorMessage(error);
      setState(message.title,message.copy);
      showToast(message.title);
      if(startPanel)startPanel.hidden=false;
      if(viewfinder)viewfinder.hidden=true;
    }finally{
      isStarting=false;
      if(startButton)startButton.disabled=false;
    }
  }

  async function switchCamera(){
    facingMode=facingMode==="environment" ? "user" : "environment";
    await startCamera();
  }

  function videoDimensions(){
    var width=video && video.videoWidth ? video.videoWidth : 1280;
    var height=video && video.videoHeight ? video.videoHeight : 720;
    return {width:width,height:height};
  }

  function canvasToBlob(canvasElement){
    return new Promise(function(resolve,reject){
      canvasElement.toBlob(function(blob){
        if(blob)resolve(blob);
        else reject(new Error("Could not create image"));
      },"image/jpeg",0.92);
    });
  }

  async function capturePhoto(){
    if(!video || !stream)return;

    var dimensions=videoDimensions();
    canvas.width=dimensions.width;
    canvas.height=dimensions.height;

    var context=canvas.getContext("2d");
    if(!context){
      showToast("Photo capture is unavailable.");
      return;
    }

    if(facingMode==="user"){
      context.translate(canvas.width,0);
      context.scale(-1,1);
    }

    context.drawImage(video,0,0,canvas.width,canvas.height);

    try{
      capturedBlob=await canvasToBlob(canvas);
      revokeCapturedUrl();
      capturedObjectUrl=URL.createObjectURL(capturedBlob);
      previewImage.src=capturedObjectUrl;

      stopCamera();

      if(viewfinder)viewfinder.hidden=true;
      if(startPanel)startPanel.hidden=true;
      if(preview)preview.hidden=false;
      if(stageActions)stageActions.hidden=false;

      setState(
        "Photo captured",
        "Review the photo, then retake it or continue to Memory Details."
      );
    }catch(error){
      showToast("The photo could not be captured.");
    }
  }

  async function loadFile(file){
    if(!file || !file.type || file.type.indexOf("image/")!==0){
      showToast("Choose an image file.");
      return;
    }

    stopCamera();
    resetPreview();

    capturedBlob=file;
    capturedObjectUrl=URL.createObjectURL(file);
    previewImage.src=capturedObjectUrl;

    if(startPanel)startPanel.hidden=true;
    if(viewfinder)viewfinder.hidden=true;
    if(preview)preview.hidden=false;
    if(stageActions)stageActions.hidden=false;

    setState(
      "Photo selected",
      "Review the photo, then continue to Memory Details."
    );
  }

  function enableEditor(){
    if(!capturedBlob)return;

    editorReady=true;
    if(editorDisabled)editorDisabled.hidden=true;
    if(editorControls)editorControls.hidden=false;

    setState(
      "Ready to remember",
      "Add a caption, save this memory, or share it when you are ready."
    );

    root.querySelector("#wl-camera-editor").scrollIntoView({
      behavior:"smooth",
      block:"start"
    });
  }

  function updateCaptionCount(){
    if(!captionInput || !captionCount)return;
    var max=Number(config.maxCaptionLength)||180;
    captionCount.textContent=captionInput.value.length+" / "+max;
  }

  function fileName(){
    var now=new Date();
    var stamp=[
      now.getFullYear(),
      String(now.getMonth()+1).padStart(2,"0"),
      String(now.getDate()).padStart(2,"0"),
      "-",
      String(now.getHours()).padStart(2,"0"),
      String(now.getMinutes()).padStart(2,"0")
    ].join("");

    return "waglife-memory-"+stamp+".jpg";
  }

  function readStoredMemories(){
    try{
      var raw=window.localStorage.getItem(memoryStorageKey);
      var parsed=raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    }catch(error){
      return [];
    }
  }

  function writeStoredMemories(memories){
    try{
      window.localStorage.setItem(
        memoryStorageKey,
        JSON.stringify(memories.slice(0,maxStoredMemories))
      );
      return true;
    }catch(error){
      return false;
    }
  }

  function blobToDataUrl(blob){
    return new Promise(function(resolve,reject){
      var reader=new FileReader();
      reader.onload=function(){resolve(String(reader.result||""));};
      reader.onerror=function(){reject(new Error("Could not read memory image"));};
      reader.readAsDataURL(blob);
    });
  }

  function formatMemoryDate(timestamp){
    try{
      return new Intl.DateTimeFormat(undefined,{
        month:"short",
        day:"numeric",
        year:"numeric"
      }).format(new Date(timestamp));
    }catch(error){
      return "Saved memory";
    }
  }

  function renderMemories(){
    if(!recentSection)return;

    var memories=readStoredMemories();
    var existing=recentSection.querySelector(".wl-memories-saved-list");
    if(existing)existing.remove();

    if(recentEmpty){
      recentEmpty.hidden=memories.length>0;
    }

    if(!memories.length)return;

    var list=document.createElement("div");
    list.className="wl-memories-saved-list";
    list.style.cssText="display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:12px;margin-top:20px;";

    memories.forEach(function(memory){
      var card=document.createElement("article");
      card.style.cssText="overflow:hidden;border:1px solid rgba(7,24,32,.10);border-radius:17px;background:#fff;";

      var image=document.createElement("img");
      image.src=memory.image;
      image.alt=memory.caption||"Saved WagLife memory";
      image.loading="lazy";
      image.style.cssText="width:100%;aspect-ratio:4/3;display:block;object-fit:cover;background:#0b313a;";

      var body=document.createElement("div");
      body.style.cssText="padding:13px;";

      var title=document.createElement("strong");
      title.textContent=memory.caption||"A good dog day";
      title.style.cssText="display:block;font-size:12px;line-height:1.4;";

      var date=document.createElement("small");
      date.textContent=formatMemoryDate(memory.createdAt);
      date.style.cssText="display:block;margin-top:6px;color:#68787d;font-size:9px;";

      body.appendChild(title);
      body.appendChild(date);
      card.appendChild(image);
      card.appendChild(body);
      list.appendChild(card);
    });

    recentSection.appendChild(list);
  }

  async function storeCurrentMemory(){
    if(!capturedBlob)return false;

    try{
      var image=await blobToDataUrl(capturedBlob);
      var caption=captionInput ? captionInput.value.trim() : "";
      var memories=readStoredMemories();

      memories.unshift({
        id:"memory-"+Date.now(),
        createdAt:new Date().toISOString(),
        caption:caption,
        image:image
      });

      var saved=writeStoredMemories(memories);
      if(saved)renderMemories();
      return saved;
    }catch(error){
      return false;
    }
  }

  async function savePhoto(){
    if(!capturedBlob){
      showToast("Capture or choose a photo first.");
      return;
    }

    var stored=await storeCurrentMemory();

    var url=URL.createObjectURL(capturedBlob);
    var link=document.createElement("a");
    link.href=url;
    link.download=fileName();
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(function(){
      URL.revokeObjectURL(url);
    },1000);

    showToast(
      stored
        ? "Memory saved to WagLife and your device."
        : "Memory saved to your device."
    );
  }

  async function sharePhoto(){
    if(!capturedBlob){
      showToast("Capture or choose a photo first.");
      return;
    }

    var caption=captionInput ? captionInput.value.trim() : "";
    var file=new File(
      [capturedBlob],
      fileName(),
      {type:capturedBlob.type||"image/jpeg"}
    );

    if(navigator.share){
      try{
        var shareData={
          title:config.shareTitle||"WagLife Memory",
          text:caption||"A memory from a good day with WagLife."
        };

        if(navigator.canShare && navigator.canShare({files:[file]})){
          shareData.files=[file];
        }

        await navigator.share(shareData);
        showToast("Memory share sheet opened.");
        return;
      }catch(error){
        if(error && error.name==="AbortError")return;
      }
    }

    savePhoto();

    if(caption && navigator.clipboard && navigator.clipboard.writeText){
      try{
        await navigator.clipboard.writeText(caption);
        showToast("Memory saved and caption copied.");
        return;
      }catch(error){}
    }

    showToast("Memory saved. Sharing is unavailable here.");
  }

  function takeAnother(){
    resetPreview();
    if(captionInput){
      captionInput.value="";
      updateCaptionCount();
    }
    startCamera();
  }

  function handleVisibilityChange(){
    if(document.hidden && stream){
      stopCamera();
      if(viewfinder)viewfinder.hidden=true;
      if(startPanel)startPanel.hidden=false;
      setState(
        "Camera paused",
        "Open the camera again when you return."
      );
    }
  }

  if(saveButton)saveButton.textContent="Save Memory";
  if(shareButton)shareButton.textContent="Share Memory";
  if(newPhotoButton)newPhotoButton.textContent="Create Another Memory";
  if(usePhotoButton)usePhotoButton.textContent="Use This Photo";
  renderMemories();

  if(startButton)startButton.addEventListener("click",startCamera);
  if(switchButton)switchButton.addEventListener("click",switchCamera);
  if(shutterButton)shutterButton.addEventListener("click",capturePhoto);
  if(closeCameraButton)closeCameraButton.addEventListener("click",showStartState);

  if(flashButton){
    flashButton.addEventListener("click",function(){
      showToast("Flash control is not available in this browser.");
    });
  }

  if(fileInput){
    fileInput.addEventListener("change",function(){
      var file=fileInput.files && fileInput.files[0];
      if(file)loadFile(file);
      fileInput.value="";
    });
  }

  if(retakeButton)retakeButton.addEventListener("click",startCamera);
  if(usePhotoButton)usePhotoButton.addEventListener("click",enableEditor);
  if(saveButton)saveButton.addEventListener("click",savePhoto);
  if(shareButton)shareButton.addEventListener("click",sharePhoto);
  if(newPhotoButton)newPhotoButton.addEventListener("click",takeAnother);

  if(captionInput){
    captionInput.addEventListener("input",updateCaptionCount);
    updateCaptionCount();
  }

  root.querySelectorAll("[data-caption]").forEach(function(button){
    button.addEventListener("click",function(){
      if(!captionInput)return;
      captionInput.value=button.getAttribute("data-caption")||"";
      updateCaptionCount();
      captionInput.focus();
    });
  });

  if(helpButton){
    helpButton.addEventListener("click",function(){
      showToast("Take or choose a photo, add the story, then save or share your WagLife memory.");
    });
  }

  document.addEventListener("visibilitychange",handleVisibilityChange);
  window.addEventListener("pagehide",stopCamera);
})();